/* rhoneprints: 1s and 0s falling down the page, mixed sizes, sparse so it stays in the background */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var c = document.createElement('canvas');
  c.setAttribute('aria-hidden', 'true');
  c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9994';
  var ctx = c.getContext('2d');
  if (!ctx) return;
  var W = 0, H = 0, dpr = 1, drops = [];
  var COLORS = ['#1c8a99', '#7a1c69', '#3a3f8f', '#5a5670', '#1c8a99', '#a8267f'];
  function count() { return W < 750 ? 16 : Math.min(46, Math.round(W / 34)); }
  function make(fresh) {
    var size = 9 + Math.pow(Math.random(), 1.6) * 30;
    return {
      x: Math.random() * W,
      y: fresh ? Math.random() * H : -size * (1 + Math.random() * 6),
      size: size,
      v: 0.35 + size / 30 * 1.1 + Math.random() * 0.4,
      ch: Math.random() < 0.5 ? '0' : '1',
      col: COLORS[Math.floor(Math.random() * COLORS.length)],
      flip: 200 + Math.random() * 1600,
      t: 0
    };
  }
  function resize() {
    dpr = Math.min(2, window.devicePixelRatio || 1);
    W = window.innerWidth; H = window.innerHeight;
    c.width = W * dpr; c.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var n = count();
    while (drops.length < n) drops.push(make(true));
    if (drops.length > n) drops.length = n;
  }
  var last = 0, running = true;
  function frame(now) {
    if (!running) return;
    var dt = Math.min(50, now - last || 16);
    last = now;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < drops.length; i++) {
      var d = drops[i];
      d.y += d.v * dt / 16;
      d.t += dt;
      if (d.t > d.flip) { d.t = 0; d.ch = d.ch === '0' ? '1' : '0'; }
      if (d.y - d.size > H) { drops[i] = make(false); continue; }
      ctx.font = d.size + 'px "Space Mono", monospace';
      ctx.fillStyle = d.col;
      ctx.fillText(d.ch, d.x, d.y);
    }
    requestAnimationFrame(frame);
  }
  function mount() {
    if (!document.body || c.parentNode) return;
    document.body.appendChild(c);
    resize();
    requestAnimationFrame(frame);
  }
  window.addEventListener('resize', resize);
  document.addEventListener('visibilitychange', function () {
    running = !document.hidden;
    if (running) { last = 0; requestAnimationFrame(frame); }
  });
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);
})();
